export default class ItemKey {
  type?: string;

  id?: string;

  idParent?: string;
}
